import React, {useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    messageError,
    messageToast,
    objectLoai,
    objectLoaiNoiDung,
    objectTrangThaiDeNghi,
    status200,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import {addEmailConfigAction} from '../../store/reducers/emailConfig';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {DEPARTMENT_API, ROLE_API} from '@app/utils/apiUrl';
import {useMutation, useQuery} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Get, Post} from '@app/utils/httpProvider';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    departmentCode: yup.string().required(messageError.emptyMessage)
});

const DepartmentAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(DEPARTMENT_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        // model.lstAllowedRoles = values.lstAllowedRoles.map((x) => ({
        //     id: x.value,
        //     name: x.label
        // }));

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin đơn vị</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        departmentCode: '',
                        departmentName: '',
                        orderNumber: 0,
                        designation: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        touched,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Code đơn vị',
                                        name: 'departmentCode',
                                        value: values.departmentCode,
                                        onChange: handleChange,
                                        isInvalid:
                                            errors.departmentCode &&
                                            touched.departmentCode,
                                        error: touched.departmentCode
                                            ? errors.departmentCode
                                            : null
                                    },
                                    {
                                        label: 'Tên đơn vị',
                                        name: 'departmentName',
                                        value: values.departmentName,
                                        onChange: handleChange,
                                        isInvalid:
                                            errors.departmentName &&
                                            touched.departmentName,
                                        error: touched.departmentName
                                            ? errors.departmentName
                                            : null
                                    }
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Số thứ tự',
                                        name: 'orderNumber',
                                        type: 'number',
                                        value: values.orderNumber,
                                        onChange: handleChange
                                    },
                                    {
                                        label: 'Chức năng/Tên gọi',
                                        name: 'designation',
                                        value: values.designation,
                                        onChange: handleChange,
                                        placeholder: 'Ví dụ: Khoa lâm sàng, Phòng chức năng...'
                                    }
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default DepartmentAdd;
